import rendercarousels from "./carousels";
import renderIcons from "./renderIcons";
import renderHeader from "./header";
import CookieWidget from "./cookieWidget";
// import containerHeight from './containerHeight'
// import printBlock from './printBlock'
// import videoPlayer from "./player/videoPlayer";
// import games from "./games";
import './css/app.scss'
document.addEventListener("DOMContentLoaded", () => {
    rendercarousels();
    renderIcons();
    renderHeader();
    // containerHeight();
    // printBlock();
  //  videoPlayer();
    // games();
});
const cookieWidget = new CookieWidget({
    cookieName: 'TVCookie',
    cookieExpiryHrs: 48, // Cookie на 48 часов
    cookieTheme: 'is-dark', // сейчас 2 темы: дефолтная и тёмная
    cookieHtml: '<h3>Мы используем cookie</h3><p><a target="_blank" href="https://digitalrussia.tv?from=cine">АО «ЦТВ»</a> использует <a target="_blank" href="https://digitalrussia.tv/dtr_cookie_policy.pdf">cookie-файлы</a> и обрабатывает <a target="_blank" href="https://digitalrussia.tv/dtr_personal_data_processing_policy.pdf">персональные данные</a> для улучшения работы сайта. Подтвердите ваше согласие, нажав кнопку</p><fieldset class="acceptPolicy"><button class="btn" id="cookieSwitch">OK</button></fieldset>', // если надо заменить html виджета
    cookieScroll: 150 // если задан, то виджет инициализируется по скроллу, типа 100px
  });
window.addEventListener('load', () => {
    document.querySelector('.load').classList.remove('load')
})